// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__sD89z","loveImg":"Footer_loveImg__Ul1AW","footerImg1":"Footer_footerImg1__UQLf9","footerImg2":"Footer_footerImg2__tB7Fc"};